import { useMemo, useState } from "react";
import { Navbar } from "@/components/store/Navbar";
import { KineticHero } from "@/components/store/KineticHero";
import { EditorialMarquee } from "@/components/store/EditorialMarquee";
import { ProductGrid } from "@/components/store/ProductGrid";
import { Manifesto } from "@/components/store/Manifesto";
import { ProductQuickView } from "@/components/store/ProductQuickView";
import { CartDrawer } from "@/components/store/CartDrawer";
import { CheckoutDialog } from "@/components/store/CheckoutDialog";
import { Footer } from "@/components/store/Footer";
import { useStore } from "@/context/StoreContext";

export default function Storefront() {
  const { products } = useStore();
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [quickViewOpen, setQuickViewOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  const filteredProducts = useMemo(() => {
    if (activeCategory === "all") return products;
    return products.filter((product) => product.category === activeCategory);
  }, [products, activeCategory]);

  const quickView = (product) => {
    setSelectedProduct(product);
    setQuickViewOpen(true);
  };

  const checkout = () => {
    setCartOpen(false);
    setCheckoutOpen(true);
  };

  return (
    <main data-testid="bkg-storefront">
      <Navbar onCartOpen={() => setCartOpen(true)} />
      <KineticHero onShop={() => document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" })} />
      <EditorialMarquee />
      <ProductGrid products={filteredProducts} activeCategory={activeCategory} onCategory={setActiveCategory} onQuickView={quickView} />
      <Manifesto />
      <Footer />
      <ProductQuickView product={selectedProduct} open={quickViewOpen} onOpenChange={setQuickViewOpen} />
      <CartDrawer open={cartOpen} onOpenChange={setCartOpen} onCheckout={checkout} />
      <CheckoutDialog open={checkoutOpen} onOpenChange={setCheckoutOpen} />
    </main>
  );
}
